module.exports = __webpack_public_path__ + "img/contact.616e8a0d.png";